module.exports = __webpack_public_path__ + "static/img/mobile_home_banner.394917f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mobile_home_banner.png
// module id = iCwN
// module chunks = 21